import React from "react";
import Navbar from "../components/Navbar";

const Trending = () => {
  return (
    <div>
      <Navbar />
      <p>
        Never giving up is a testament to the resilience and determination that
        resides within each of us. It's a philosophy that acknowledges life's
        challenges, setbacks, and obstacles but refuses to be defeated by them.
        When we embrace the idea of never giving up, we open the door to growth,
        success, and personal transformation. It means pushing through the most
        challenging moments, even when the path seems insurmountable, and
        holding onto hope in the face of adversity. It's a reminder that the
        journey to our goals may be fraught with difficulties, but it's in
        persevering through those hardships that we discover our true strength
        and potential. Whether in pursuing our dreams, overcoming hurdles, or
        weathering life's storms, never giving up is a testament to the human
        spirit's indomitable will to thrive and flourish, no matter the odds.
      </p>{" "}
    </div>
  );
};

export default Trending;
